/** W1–W3 GOT Sample Dispatch (legacy Quality login, manual p115–117). Round 1: screens only. */
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { GotDispatchPage } from "@/features/got/components/dispatch-page";

const search = z.object({
  step: z.enum(["type", "dosr", "pending", "completed"]).default("type"),
  type: z.enum(["pending", "completed"]).optional(),
  dosr: z.string().optional(),
});

export const Route = createFileRoute("/_app/quality/got/dispatch")({
  validateSearch: search,
  beforeLoad: () => {
    if (!useAuth.getState().can("got.dispatch")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const s = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { selected } = useFacilities();
  return (
    <GotDispatchPage
      search={s}
      facilityId={selected?.id ?? null}
      plantName={selected ? selected.name : null}
      onSearch={(next) => void navigate({ search: next })}
    />
  );
}
